import { getConfigs } from './getConfigs';

export const configService = {
  getConfigs,
};
